module.exports = __webpack_public_path__ + "img/TOCTemp6.4cac9635.png";